/***********************
 * COLUMN WIDTHS FOR ANTD TABLE REPORTING
 ************************/

const columnWidth = {
  name: "220px",
  nameWide: "300px",
  group: "220px",
  narrow: "100px",
  medium: "160px",
  wide: "300px",
  wideXL: "700px",
  date: "170px",
}

export { columnWidth }
